export class DateSelectionRule {
  public static doEvaluate(start: Date, end: Date): boolean {
    return start.getMonth() === end.getMonth() && start.getDay() === end.getDay();
  }
}
